import React from "react";
import "./assets/scss/themes.scss";
import Routes from "./app/routes";
import { useAuthInit } from "features/Authentication/hooks/useAuthInit";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useAuthInit();

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} limit={3} position="top-right" />
      <Routes />
    </React.Fragment>
  );
}

export default App;
